import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { INCIDENT_DISPLAY_LIMIT, IncidentData } from '../types';
import {
  PhasrRecommendationsEndpoint,
  PhasrRecommendationsMethod
} from "../../../phasrRecommendations/phasrRecommendationsGrid/types";
import {ConsoleRequest, DataProviderType} from "../../../utils/request";

export class PhasrMonitoredRulesDetailsPanelDataProvider extends BaseWebComponentDataProvider {
  public async getIncidentsByRuleId(page: number, ruleId: number, companyId: string): Promise<IncidentData[]> {
    return await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: PhasrRecommendationsEndpoint.RULE_TRIGGERS,
      method: PhasrRecommendationsMethod.GET_PHASR_INCIDENTS_BY_RULE_ID,
      payload: {
        page: page,
        limit: INCIDENT_DISPLAY_LIMIT,
        companyId: companyId,
        ruleId: ruleId
      },
    }) as IncidentData[];

  }
}
